import {Component, Input, OnInit} from '@angular/core';
import {Favorite} from '@models/favorite';

@Component({
    selector: 'app-taux-locataire',
    templateUrl: './taux-locataire.component.html',
    styleUrls: ['./taux-locataire.component.scss']
})
export class TauxLocataireComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;

    constructor() {
    }

    ngOnInit() {
    }

}
